import React from "react";
import "./Card.css";

const CardSkeleton: React.FC = () => {
  return (
    <div className="card">
      <div className="card__image-container">
        <div className="skeleton-image skeleton-shimmer"></div>
      </div>

      <div className="card-content">
        <div className="skeleton-header">
          <div className="skeleton-title skeleton-shimmer"></div>
          <div className="skeleton-pill skeleton-shimmer"></div>
        </div>

        <div className="card-details">
          <div className="skeleton-line skeleton-line-short skeleton-shimmer"></div>
          <div className="skeleton-line skeleton-line-long skeleton-shimmer"></div>
          <div className="skeleton-line skeleton-line-medium skeleton-shimmer"></div>
          <div className="skeleton-link skeleton-shimmer"></div>
        </div>
      </div>
    </div>
  );
};

export default CardSkeleton;
